import GridList from '@material-ui/core/GridList';
import React from 'react';

const ShopListWrapper = ({ children, lg = false, ...rest }) =>
  lg ? children : <GridList {...rest}>{children}</GridList>;

export default ShopListWrapper;
